module.exports = __webpack_public_path__ + "img/FTHS__FantasyShield_2.32684b57.png";